export interface IFilter {
  id: string;
  label: string;
  value: number | string;
  updatedField: string;
}

export interface IFilterActionButtonLabels {
  Apply: string;
  Cancel: string;
  ClearAllButton: string;
}
